import {Mapper} from '@s-ui/domain'

export class FromDealerLocationJsonToLocationValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {LocationValueObject} param.locationValueObjectFactory
   * @param {FromJsonToGoogleMapsApiUrlsMapper} param.fromJsonToGoogleMapsApiUrlsMapper
   */
  constructor({config, locationValueObjectFactory, fromJsonToGoogleMapsApiUrlsMapper}) {
    super()

    this._config = config
    this._locationValueObjectFactory = locationValueObjectFactory
    this._fromJsonToGoogleMapsApiUrlsMapper = fromJsonToGoogleMapsApiUrlsMapper
  }

  _getCoordinates = ({geoLocation}) => {
    const hasGeoLocation = Boolean(geoLocation)

    if (!hasGeoLocation) return

    const {latitude, longitude} = geoLocation
    return {lat: String(latitude), lng: String(longitude)}
  }

  /**
   * @param {Object} rawData
   * @returns {LocationValueObject}
   */
  map = rawData => {
    const {address, city, province, provinceId, provinceIds, zipCode: postalCode, geoLocation} = rawData

    const coordinates = this._getCoordinates({geoLocation})

    const {directionsUrl: mapsDirectionsUrl} = this._fromJsonToGoogleMapsApiUrlsMapper.map({
      coordinates,
      address,
      city,
      province,
      postalCode
    })

    return this._locationValueObjectFactory({
      address,
      city,
      province,
      provinceId,
      provinceIds,
      postalCode,
      coordinates,
      mapsDirectionsUrl
    })
  }
}
